import { OverlayScrollArea } from '@odo/shared-ui';
import React, { ReactNode } from 'react';
import CategoryRail, { type CategoryRailItem } from './CategoryRail';

interface RailListLayoutProps {
    railItems: CategoryRailItem[];
    /** Breakpoint the rail appears at; passed through to CategoryRail. */
    showFrom?: 'lg' | 'xl';
    /** Layout classes for the scroll content (a column flex, a grid, ...). */
    innerClassName?: string;
    /** Rendered in place of the scroll area, e.g. a "nothing here" state. */
    emptyState?: ReactNode;
    children?: ReactNode;
}

/** The list-page shell: full-height category rail beside a list scrolling in its own bounds. */
export const RailListLayout: React.FC<RailListLayoutProps> = ({
    railItems,
    showFrom,
    innerClassName = 'flex flex-col gap-3.5',
    emptyState,
    children
}) => (
    <div className="flex gap-6 h-full min-h-0 items-stretch">
        <CategoryRail fullHeight showFrom={showFrom} items={railItems} />
        {emptyState ? (
            <div className="flex-1 min-w-0">{emptyState}</div>
        ) : (
            // pr-3: right gutter so the overlay thumb rides beside the cards.
            <OverlayScrollArea
                className="flex-1 min-w-0 h-full -ml-1"
                contentClassName="pl-1 pr-3"
                innerClassName={`${innerClassName} pb-1`}
            >
                {children}
            </OverlayScrollArea>
        )}
    </div>
);

export default RailListLayout;
